import React from 'react'
import { Box, Slider, SliderProps } from '@mui/material'

interface ColoredSliderProps extends SliderProps {
  handleChange: (
    event: Event,
    value: number | number[],
  ) => void
}

const ColoredSlider: React.FC<ColoredSliderProps> = ({
  handleChange,
  ...props
}) => {
  return (
    <Box className='h-1 w-[calc(100% - 16px)] px-3 py-0'>
<Slider 
  {...props} 
  onChange={handleChange} 
  className='text-primary bottom-4 rounded-md'
  sx={{
    color: '#6453c6', // Your custom color here
    '& .MuiSlider-thumb': {
      backgroundColor: '#6453c6', // Match thumb color
    },
    '& .MuiSlider-rail': {
      backgroundColor: '#6453c6', // Lighter shade for rail
      opacity: 0.3,
    },
    '& .MuiSlider-track': {
      backgroundColor: '#6453c6', // Match track color
    }
  }}
/>    </Box>
  )
}

export default ColoredSlider
